import { v4 as uuid } from 'uuid';

import { MESSAGES, ROLE } from '../../../constants';

export interface IBotTyping {
  id: string;
  rm: boolean;
  type: MESSAGES.BOT_TYPING;
  role: ROLE.BOT;
  avatar: boolean;
}

export const createBotTyping = (data): IBotTyping => ({
  id: data.id || uuid(),
  rm: Boolean(data.rm),
  type: MESSAGES.BOT_TYPING,
  role: ROLE.BOT,
  avatar: true,
});
